import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const DEFAULT_LOCALE = 'en';
export const SUPPORTED_LOCALES = ['en', 'ar'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

const RTL_LOCALES: readonly string[] = ['ar'];

/** Applies a locale to both the translation service and the document's lang/dir attributes. */
@Injectable({ providedIn: 'root' })
export class LocaleService {
  private readonly translate = inject(TranslateService);

  readonly supportedLocales = SUPPORTED_LOCALES;

  apply(locale: string | null | undefined): void {
    const resolved = (SUPPORTED_LOCALES as readonly string[]).includes(locale ?? '') ? (locale as string) : DEFAULT_LOCALE;
    this.translate.use(resolved);
    document.documentElement.lang = resolved;
    document.documentElement.dir = RTL_LOCALES.includes(resolved) ? 'rtl' : 'ltr';
  }
}
